import { FC } from "react";
import { useItemContext } from "./context";
import classNames from "classnames";

interface  ItemDescriptionProps {
    className?: string;
    [key: string]: any;
}

const ItemDescription: FC<ItemDescriptionProps> = ({className, ...props}) => {
    const item = useItemContext();

    if (!item?.description) {
        return null;
    }

    return (
        <div
            className={classNames("ql-container ql-editor", className)}
            dangerouslySetInnerHTML={{ __html: item.description }}
            {...props} />
    )
}

export default ItemDescription;